import type { menuItems, ThreeDotsItemKind } from "../Icon/ThreeDotsDropdownMenu";
import ThreeDotsDropdownMenu from "../Icon/ThreeDotsDropdownMenu";
import type { IProjectGroupWithProjects } from "../../../features/projectGroups/state/projectGroupsSlice";

interface DisplayThreeDotsDropdownMenuProps {
  isEnduser: boolean;
  menuItems: menuItems;
  pg: IProjectGroupWithProjects;
  handleThreeDotButtonClick: ({
    item,
    itemId,
    action,
  }: {
    item: ThreeDotsItemKind;
    itemId: number;
    action: string;
  }) => void;
  setEditedProjectGroupId?: (id: number, projectGroup: IProjectGroupWithProjects) => void;
}

const DisplayThreeDotsDropdownMenu = ({
  menuItems,
  pg,
  handleThreeDotButtonClick,
  isEnduser,
  setEditedProjectGroupId,
}: DisplayThreeDotsDropdownMenuProps) => {
  if (!isEnduser) {
    return (
      <div
        className="absolute top-3 right-3 h-6 w-6 rounded-md z-10 mr-4"
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
        }}
      >
        <ThreeDotsDropdownMenu
          type="projectGroup"
          className="h-6 w-6"
          menuItems={menuItems}
          currentProjectGroupId={pg.id}
          currentProjectGroup={pg}
          setEditedProjectGroupId={setEditedProjectGroupId}
          handleClick={(e) =>
            handleThreeDotButtonClick({
              item: "projectGroup",
              itemId: pg.id,
              action: e.itemId ?? "",
            })
          }
        />
      </div>
    );
  } else {
    return <></>;
  }
};

export default DisplayThreeDotsDropdownMenu;
